import React from 'react';
import { IconWrapper, SvgIcon } from '../../../../Icon';
import toastMessage from '../../../../../utils/toastMessage';
import KubitTooltip from '../../../../KubitTooltip';
import { buttonClicked } from '../../../../../utils/analytics/events/button/events';
import { useAnalytics } from '../../../../../utils/analytics/useAnalytics';
import copyTextToClipboard from '../../../../../utils/copyTextToClipboard';

interface IProps {
  reportLink: string;
}

const CopyChartLinkButton = ({ reportLink }: IProps) => {
  const { track } = useAnalytics();
  const copyToClipboardLink = `${window.location.origin}${reportLink}`;

  const onCopyLink = async (event: React.MouseEvent) => {
    event.stopPropagation();

    await copyTextToClipboard(copyToClipboardLink);

    track(buttonClicked({ context: 'reports', action: 'copy_link' }));

    toastMessage({
      message: 'Report URL Copied!',
      type: 'info',
    });
  };

  return (
    <KubitTooltip
      content="Copy chart link."
      placement="bottom-end"
      noOpenDelay={true}
    >
      <IconWrapper size={24} onClick={onCopyLink}>
        <SvgIcon name="link-regular" width={16} height={16} />
      </IconWrapper>
    </KubitTooltip>
  );
};

export default CopyChartLinkButton;
